// FinTrack — Kontni Plan (RS -> EN mapiranje konta)
// Cuva se u Supabase bazi (tabela kontni_plan)
// Podrzava upload Excel-a, prikaz, pretragu, CRUD i export

import { state, PAGE_SIZE } from './state.js';
import { sb } from './supabase.js';
import { toast, clMdl, svgIcon, openEditModal, showConfirm } from './ui.js';
import { paginate, renderPagination } from './utils.js';
import XLSX from 'xlsx-js-style';

let kpSortCol = 'rsKonto', kpSortAsc = true;

// LOAD from Supabase
export async function loadKontniPlan() {
  try {
    const { data, error } = await sb.from('kontni_plan').select('*').is('deleted_at', null).order('rs_konto');
    if (error) throw error;
    state.kontniPlan = (data || []).map(r => ({ id: r.id, rsKonto: r.rs_konto, rsName: r.rs_name, enKonto: r.en_konto, enName: r.en_name, type: r.account_type }));
    state.kpLoaded = true;
  } catch (e) {
    toast('Gre\u0161ka pri u\u010ditavanju kontnog plana: ' + e.message, 'err');
  }
}

// UPLOAD EXCEL — bulk import u bazu
export async function handleKPFile(inp) {
  if (!inp.files.length) return;
  const f = inp.files[0];
  const r = new FileReader(); r.onload = async e => {
    try {
      const wb = XLSX.read(e.target.result, { type: 'array' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: '' });
      if (rows.length < 2) { toast('Excel je prazan', 'err'); return; }
      const hdr = rows[0].map(h => String(h || '').toLowerCase().trim());
      const ci = name => { for (let i = 0; i < hdr.length; i++) { if (hdr[i].includes(name)) return i; } return -1; };
      const cRS = ci('rs konto') >= 0 ? ci('rs konto') : ci('konto');
      const cSR = ci('naziv (sr)') >= 0 ? ci('naziv (sr)') : (ci('naziv') >= 0 ? ci('naziv') : ci('sr'));
      const cEN = ci('us konto') >= 0 ? ci('us konto') : (ci('en konto') >= 0 ? ci('en konto') : ci('us'));
      const cENn = ci('naziv (en)') >= 0 ? ci('naziv (en)') : (ci('en') >= 0 && ci('en') !== cEN ? ci('en') : -1);
      const cType = ci('type') >= 0 ? ci('type') : ci('tip');
      const items = [];
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        const rs = row[cRS] != null ? String(row[cRS]).trim() : '';
        if (!rs) continue;
        items.push({
          rsKonto: rs,
          rsName: cSR >= 0 ? String(row[cSR] || '').trim() : '',
          enKonto: cEN >= 0 ? String(row[cEN] || '').trim() : '',
          enName: cENn >= 0 ? String(row[cENn] || '').trim() : '',
          type: cType >= 0 ? String(row[cType] || '').trim() : ''
        });
      }
      const doImport = async (mode) => {
        const rpcName = mode === 'merge' ? 'merge_kontni_plan' : 'import_kontni_plan';
        const { data, error } = await sb.rpc(rpcName, { p_user_id: state.CU.id, p_data: items });
        if (error) throw error;
        toast(items.length + ' konta importovano u bazu');
        await loadKontniPlan();
        renderKontniPlan();
      };
      if (state.kontniPlan.length > 0) {
        showConfirm('Kontni plan ima ' + state.kontniPlan.length + ' konta. Zameniti sve ili spojiti?', () => doImport('replace'));
        return; // modal je async — ne nastavlja sinhrono
      }
      await doImport('replace');
    } catch (err) { toast('Gre\u0161ka: ' + err.message, 'err'); }
  }; r.readAsArrayBuffer(f);
  inp.value = '';
}

// RENDER
export function renderKontniPlan() {
  const tbody = document.getElementById('kpBody');
  const empty = document.getElementById('kpEmpty');
  if (!tbody) return;
  if (!state.kontniPlan.length) { tbody.textContent = ''; if (empty) empty.style.display = 'block'; return; }
  if (empty) empty.style.display = 'none';
  // Build sortable headers
  const thead = document.querySelector('#pg-kontni-plan .dtbl thead tr');
  if (thead) {
    thead.textContent = '';
    const cols = [
      { key: null, label: '', isCheck: true },
      { key: 'rsKonto', label: 'RS Konto' }, { key: 'rsName', label: 'Naziv (SR)' },
      { key: 'enKonto', label: 'EN Konto' }, { key: 'enName', label: 'Naziv (EN)' },
      { key: 'type', label: 'Tip' }, { key: null, label: '' }
    ];
    cols.forEach(c => {
      const th = document.createElement('th');
      if (c.isCheck) {
        th.style.width = '30px';
        const ck = document.createElement('input'); ck.type = 'checkbox'; ck.id = 'kpSelectAll';
        ck.onchange = function() { toggleKpSelectAll(this.checked); };
        th.appendChild(ck);
      } else {
        th.textContent = c.label;
        if (c.key) {
          th.className = 'sortable' + (kpSortCol === c.key ? (kpSortAsc ? ' asc' : ' desc') : '');
          const si = document.createElement('span'); si.className = 'sort-icon';
          si.textContent = kpSortCol === c.key ? (kpSortAsc ? '\u25B2' : '\u25BC') : '\u25B4';
          th.appendChild(si);
          th.onclick = () => { if (kpSortCol === c.key) kpSortAsc = !kpSortAsc; else { kpSortCol = c.key; kpSortAsc = true; } state.kpPage = 0; renderKontniPlan(); };
        }
      }
      thead.appendChild(th);
    });
  }

  const s = (document.getElementById('kpSrch')?.value || '').toLowerCase();
  let fl = s ? state.kontniPlan.filter(k =>
    k.rsKonto.toLowerCase().includes(s) ||
    k.rsName.toLowerCase().includes(s) ||
    k.enKonto.toLowerCase().includes(s) ||
    k.enName.toLowerCase().includes(s) ||
    k.type.toLowerCase().includes(s)
  ) : state.kontniPlan;

  // Sort
  fl = [...fl].sort((a, b) => {
    const va = String(a[kpSortCol] || '').toLowerCase();
    const vb = String(b[kpSortCol] || '').toLowerCase();
    return kpSortAsc ? va.localeCompare(vb) : vb.localeCompare(va);
  });

  if (s) state.kpPage = 0;
  const pg = paginate(fl, state.kpPage, PAGE_SIZE);
  tbody.textContent = '';
  pg.items.forEach(k => {
    const tr = document.createElement('tr');
    const tdCk = document.createElement('td'); const ck = document.createElement('input'); ck.type = 'checkbox'; ck.className = 'kp-ck'; ck.value = k.id; ck.onchange = () => updateKpDelBtn(); tdCk.appendChild(ck);
    const td1 = document.createElement('td'); td1.style.fontFamily = 'var(--mn)'; td1.style.fontWeight = '600'; td1.textContent = k.rsKonto;
    const td2 = document.createElement('td'); td2.textContent = k.rsName;
    const td3 = document.createElement('td'); td3.style.fontFamily = 'var(--mn)'; td3.style.color = 'var(--acc)'; td3.textContent = k.enKonto;
    const td4 = document.createElement('td'); td4.textContent = k.enName;
    const td5 = document.createElement('td'); const sp = document.createElement('span'); sp.className = 'kp-type'; sp.textContent = k.type; td5.appendChild(sp);
    const td6 = document.createElement('td');
    const acts = document.createElement('div'); acts.style.display = 'flex'; acts.style.gap = '4px'; acts.style.justifyContent = 'flex-end';
    const be = document.createElement('button'); be.className = 'bico'; be.appendChild(svgIcon('edit', 14)); be.onclick = () => editKonto(k.id);
    const bd = document.createElement('button'); bd.className = 'bico del'; bd.appendChild(svgIcon('trash', 14)); bd.onclick = () => delKonto(k.id, k.rsKonto);
    acts.appendChild(be); acts.appendChild(bd); td6.appendChild(acts);
    tr.appendChild(tdCk); tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6);
    tbody.appendChild(tr);
  });
  // Pagination
  const existingPag = document.getElementById('kpPagination');
  if (existingPag) existingPag.remove();
  if (pg.pages > 1) {
    const pagEl = renderPagination('kpPagination', pg.page, pg.pages, p => { state.kpPage = p; renderKontniPlan(); });
    const card = tbody.closest('.card');
    if (card) card.insertAdjacentElement('afterend', pagEl);
  }
  updateKpDelBtn();
}

// CRUD — preko Supabase RPC
export function showAddKonto() {
  document.getElementById('mkpTitle').textContent = 'Dodaj konto';
  document.getElementById('mkpRs').value = ''; document.getElementById('mkpSrName').value = '';
  document.getElementById('mkpEn').value = ''; document.getElementById('mkpEnName').value = '';
  document.getElementById('mkpType').value = 'Expenses'; document.getElementById('mkpIdx').value = '';
  document.getElementById('mdlKonto').classList.add('active');
}

export function editKonto(id) {
  const k = state.kontniPlan.find(x => x.id === id); if (!k) return;
  document.getElementById('mkpTitle').textContent = 'Izmeni konto';
  document.getElementById('mkpRs').value = k.rsKonto; document.getElementById('mkpSrName').value = k.rsName;
  document.getElementById('mkpEn').value = k.enKonto; document.getElementById('mkpEnName').value = k.enName;
  document.getElementById('mkpType').value = k.type || 'Expenses'; document.getElementById('mkpIdx').value = id;
  document.getElementById('mdlKonto').classList.add('active');
}

export async function saveKonto() {
  const rs = document.getElementById('mkpRs').value.trim();
  const srN = document.getElementById('mkpSrName').value.trim();
  const en = document.getElementById('mkpEn').value.trim();
  const enN = document.getElementById('mkpEnName').value.trim();
  const tp = document.getElementById('mkpType').value;
  const id = document.getElementById('mkpIdx').value;
  if (!rs) { toast('Unesite RS konto', 'err'); return; }
  if (!/^[0-9a-zA-Z,\-]{1,20}$/.test(rs)) { toast('RS konto: samo cifre, slova, zarez (max 20)', 'err'); return; }
  try {
    const { error } = await sb.rpc('upsert_konto', {
      p_user_id: state.CU.id, p_rs_konto: rs, p_rs_name: srN,
      p_en_konto: en, p_en_name: enN, p_account_type: tp,
      p_konto_id: id ? parseInt(id) : null
    });
    if (error) throw error;
    clMdl('mdlKonto');
    await loadKontniPlan(); renderKontniPlan();
    toast(id ? 'Konto azuriran' : 'Konto dodat');
  } catch (e) { toast(e.message || 'Gre\u0161ka', 'err'); }
}

export async function delKonto(id, code) {
  showConfirm('Obrisati konto ' + code + '?', async () => { try {
    const { error } = await sb.rpc('delete_konto', { p_user_id: state.CU.id, p_konto_id: id });
    if (error) throw error;
    await loadKontniPlan(); renderKontniPlan(); toast('Obrisano');
  } catch (e) { toast(e.message || 'Gre\u0161ka', 'err'); } });
}

// EXPORT
export function expKontniPlan() {
  if (!state.kontniPlan.length) { toast('Nema konta za export', 'err'); return; }
  const wb = XLSX.utils.book_new();
  function borderAll(c) { const b = { style: 'thin', color: { rgb: c } }; return { top: b, bottom: b, left: b, right: b }; }
  function cs(v, s) { return { v, s, t: typeof v === 'number' ? 'n' : 's' }; }
  const stH = { font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 }, fill: { fgColor: { rgb: '0F1923' } }, alignment: { horizontal: 'center' }, border: borderAll('CCCCCC') };
  const stN = { font: { sz: 10 }, border: borderAll('E2E8F0') };
  const data = [];
  data.push(['Naziv (SR)', 'Naziv (EN)', 'Type', 'rs konto', 'us konto'].map(h => cs(h, stH)));
  state.kontniPlan.forEach(k => {
    data.push([cs(k.rsName, stN), cs(k.enName, stN), cs(k.type, stN), cs(k.rsKonto, stN), cs(k.enKonto, stN)]);
  });
  const ws = XLSX.utils.aoa_to_sheet(data.map(r => r.map(c => c.v)));
  ws['!cols'] = [{ wch: 38 }, { wch: 42 }, { wch: 20 }, { wch: 12 }, { wch: 10 }];
  data.forEach((row, ri) => { row.forEach((cell, ci) => { const addr = XLSX.utils.encode_cell({ r: ri, c: ci }); if (!ws[addr]) ws[addr] = { v: cell.v, t: cell.t || 's' }; ws[addr].s = cell.s; }); });
  XLSX.utils.book_append_sheet(wb, ws, 'Kontni Plan');
  XLSX.writeFile(wb, 'kontni_plan.xlsx', { bookSST: false, cellStyles: true });
  if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'export_excel', p_entity_type: 'kontni_plan', p_entity_name: 'kontni_plan.xlsx' }).then(null, e => console.error('SBIS:', e));
  toast('Excel eksportovan');
}

// BATCH SELECT/DELETE
export function toggleKpSelectAll(checked) { document.querySelectorAll('.kp-ck').forEach(c => { c.checked = checked; }); updateKpDelBtn(); }
export function updateKpDelBtn() { const cnt = document.querySelectorAll('.kp-ck:checked').length; const btn = document.getElementById('kpDelSelBtn'); if (btn) btn.style.display = cnt > 0 ? 'inline-flex' : 'none'; if (btn && cnt) { btn.textContent = ''; btn.appendChild(svgIcon('trash', 14)); btn.appendChild(document.createTextNode(' Obri\u0161i (' + cnt + ')')); } }
export async function batchDeleteKonta() {
  const ids = [...document.querySelectorAll('.kp-ck:checked')].map(c => parseInt(c.value));
  if (!ids.length) return;
  showConfirm('Obrisati ' + ids.length + ' konto(a)?', async () => {
    try {
      const { error } = await sb.rpc('batch_delete_konta', { p_user_id: state.CU.id, p_ids: ids });
      if (error) throw error;
      await loadKontniPlan(); state.kpPage = 0; renderKontniPlan(); toast(ids.length + ' konto(a) obrisano');
    } catch (e) { toast(e.message || 'Gre\u0161ka', 'err'); }
  });
}

// MAPPING LOOKUP — koristi se iz knjizenja.js
export function lookupKonto(rsCode) {
  if (!rsCode) return null;
  const code = String(rsCode).trim();
  let m = state.kontniPlan.find(k => k.rsKonto === code);
  if (m) return m;
  m = state.kontniPlan.find(k => k.rsKonto.split(',').map(s => s.trim()).includes(code));
  if (m) return m;
  for (let len = code.length; len >= 2; len--) {
    const prefix = code.substring(0, len);
    m = state.kontniPlan.find(k => k.rsKonto === prefix);
    if (m) return m;
  }
  return null;
}
